import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Erdem YILMAZ
 * id C4B3CA22-1868-4216-807B-ED852BAA3C21
 * name palette-swatch-variant
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/palette-swatch-variant.svg
 * tags
 * - Drawing / Art 
 * - Color 
 */
export const PaletteSwatchVariantIcon = createSvgIcon(<><path d="M20 14H6C3.8 14 2 15.8 2 18S3.8 22 6 22H20C21.1 22 22 21.1 22 20V16C22 14.9 21.1 14 20 14M6 20C4.9 20 4 19.1 4 18S4.9 16 6 16 8 16.9 8 18 7.1 20 6 20M6.3 12L13 5.3C13.8 4.5 15 4.5 15.8 5.3L18.6 8.1C19.4 8.9 19.4 10.1 18.6 10.9L17.7 12H6.3M2 13.5V4C2 2.9 2.9 2 4 2H8C9.1 2 10 2.9 10 4V5.5L2 13.5Z" /></>, 'PaletteSwatchVariantIcon');
export default PaletteSwatchVariantIcon